// Copyright (c) 2018 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

const ModalHeader = props =>
    <header>
        <span>
            <FormattedMessage id={props.modalTitle}/>
        </span>
        <span
            className='close-modal-icon'
            onClick={props.onCloseButtonClick}
        />
    </header>;

ModalHeader.displayName = 'ModalHeader';
ModalHeader.propTypes = {
    modalTitle: PropTypes.string.isRequired,
    onCloseButtonClick: PropTypes.func.isRequired
};

export default ModalHeader;



// WEBPACK FOOTER //
// ./src/shared/components/modal-header.js